/* unplugin-vue-components disabled */import script from "./DishesOrderDetailCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DishesOrderDetailCard.vue?vue&type=script&setup=true&lang=js"

import "./DishesOrderDetailCard.vue?vue&type=style&index=0&id=7bd93223&lang=scss"

const __exports__ = script;

export default __exports__